import { isMobile } from "react-device-detect";
import { BsArrowDownShort, BsArrowUpShort } from "react-icons/bs";
import Skeleton from "react-loading-skeleton";

export default function loadingSkeleton(): JSX.Element {
  return (
    <div
      className={
        isMobile
          ? "az-content az-content-mail"
          : "az-content az-content-mail mg-t-20"
      }
    >
      <div className="container mg-b-20">
        <div className="content-wrapper w-100">
          <div className="row">
            <div className="col-lg-12">
              <div className="card" style={{ borderRadius: 20 }}>
                <div className="card-body">
                  <div className="d-sm-flex pb-4 mb-4 border-bottom">
                    <div className="d-flex align-items-center">
                      <h4 className="page-title mb-n2">Ranking</h4>
                    </div>
                    <form className="ml-lg-auto d-flex pt-2 pt-md-0 align-items-stretch justify-content-end">
                      <input
                        type="text"
                        className="form-control w-100"
                        placeholder="Buscar ativo..."
                      />
                    </form>
                  </div>

                  <div className="tab-content border-0 tab-content-basic animated fadeInDown">
                    <div className="float-right"></div>
                    <div
                      className="tab-pane fade show active"
                      id="open-tickets"
                      role="tabpanel"
                      aria-labelledby="open-tickets"
                    >
                      <div className="tickets-date-group">
                        <i className="typcn icon typcn-calendar-outline" />
                        Classificação: Data de atualização
                      </div>

                      {[1, 2, 3, 4, 5].map(() => {
                        return (
                          <div className="tickets-card row">
                            <div className="tickets-details col-lg-8">
                              <div className="wrapper">
                                <Skeleton
                                  width={40}
                                  height={40}
                                  borderRadius={50}
                                />
                                <Skeleton width={150} />
                              </div>
                              <div className="wrapper text-muted d-none d-md-block">
                                <span className="mg-t-10"></span>
                              </div>
                            </div>
                            <div className="ticket-float col-lg-2 col-sm-6">
                              <i>
                                <BsArrowUpShort size={30} color="green" />
                              </i>
                              <span className="pd-r-10 tx-bold tx-30">
                                <Skeleton width={35} />
                              </span>
                            </div>
                            <div className="ticket-float col-lg-2 col-sm-6">
                              <i>
                                <BsArrowDownShort size={30} color="red" />
                              </i>
                              <span className="pd-r-10 tx-bold tx-30">
                                <Skeleton width={35} />
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
